const sendWithFetch = (url, payload, keepalive = true) => {
  window.fetch(url, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    keepalive })
    .then(response => response.text())
    .catch(error => error);
};

const sendFormDataWithFetch = (url, payload, keepalive = true) => {
  window.fetch(url, {
    method: 'POST',
    body: payload,
    keepalive,
  })
    .then(response => response.text())
    .catch(error => error);
};

const getWithFetch = (url, options = {}) => window.fetch(url, options);

const beaconWithFetchFallback = (url, payload) => {
  const payloadString = JSON.stringify(payload);
  if (!(window.navigator && window.navigator.sendBeacon && window.navigator.sendBeacon(url, payloadString))) {
    sendWithFetch(url, payloadString);
  }
};

module.exports = {
  beaconWithFetchFallback,
  sendWithFetch,
  sendFormDataWithFetch,
  getWithFetch,
};
